// config.js
const ENV = window.location.hostname === 'localhost' ? 'development' : 'production';

const config = {
  development: {
    apiUrl: 'http://127.0.0.1:8000',
    frontendUrl: 'http://localhost:8001',
    wsHost: 'http://127.0.0.1:6001',
    storageUrl: 'http://127.0.0.1:8000/storage'
  },
  production: {
    apiUrl: 'https://admin.awogamingdeluxe.club',     // API Backend
    frontendUrl: 'https://www.awogamingdeluxe.club',   // URL Frontend
    wsHost: 'admin.awogamingdeluxe.club', // WebSocket
    storageUrl: 'https://admin.awogamingdeluxe.club/storage'
  }
};

const currentConfig = config[ENV];

export default {
  apiUrl: currentConfig.apiUrl,
  wsHost: currentConfig.wsHost,
  storageUrl: currentConfig.storageUrl,
  
  // Endpoints base
  endpoints: {
    api: `${currentConfig.apiUrl}/api/v1`,
    games: `${currentConfig.apiUrl}/api/groups`,
    broadcasting: `${currentConfig.apiUrl}/broadcasting/auth`,
    jackpots: `${currentConfig.frontendUrl}/jackpots` // Nueva URL para jackpots
  },

  // Configuraciones específicas
  wsConfig: {
    broadcaster: 'socket.io',
    forceTLS: ENV === 'production',
    encrypted: ENV === 'production',
    transports: ['websocket', 'polling']
  }
};